module.exports = __webpack_public_path__ + "img/semesterNull.fb5cfa70.png";